var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgeBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 104,
    viewBox: "0 0 96 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1767_5168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.042 7.6762C46.8769 6.6364 49.1231 6.6364 50.958 7.6762L80.4651 24.3966C82.3451 25.4619 83.507 27.4559 83.507 29.6168V62.8647C83.507 65.0256 82.3451 67.0195 80.4651 68.0849L50.958 84.8053C49.1231 85.8451 46.8769 85.8451 45.042 84.8053L15.5349 68.0849C13.6549 67.0195 12.493 65.0256 12.493 62.8647V29.6168C12.493 27.4559 13.6549 25.4619 15.5349 24.3966L45.042 7.6762Z",
    fill: "url(#paint0_linear_1767_5168)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9407 33.0416C40.3884 34.1031 36.7239 37.7132 35.6048 42.2389C34.4823 46.779 35.767 51.4068 39.0417 54.6181C40.2 55.7541 40.8916 57.5748 40.8916 59.4886V59.7941C40.8916 61.0544 41.4415 62.1884 42.3134 62.97V65.4813C42.3134 67.8333 44.2269 69.7467 46.5788 69.7467H49.4224C51.7744 69.7467 53.6878 67.8333 53.6878 65.4813V62.97C54.5597 62.1884 55.1096 61.0545 55.1096 59.7941V59.4831C55.1096 57.5983 55.8382 55.743 57.0587 54.5199C59.4692 52.1041 60.7968 48.8942 60.7968 45.4814C60.7968 37.3223 53.2358 31.1082 44.9407 33.0416ZM50.8442 65.4813C50.8442 66.2653 50.2064 66.9031 49.4224 66.9031H46.5788C45.7949 66.9031 45.157 66.2653 45.157 65.4813V64.0595H50.8442V65.4813ZM55.0457 52.5113C53.2792 54.2817 52.266 56.8227 52.266 59.4831V59.7941C52.266 60.5781 51.6282 61.2159 50.8442 61.2159H45.157C44.3731 61.2159 43.7352 60.5781 43.7352 59.7941V59.4886C43.7352 56.7873 42.7501 54.2721 41.0326 52.5878C38.4838 50.0883 37.4867 46.4748 38.3652 42.9214C39.2301 39.4231 42.0646 36.6321 45.5864 35.811C52.0956 34.2932 57.9532 39.1523 57.9532 45.4814C57.9532 48.1358 56.9206 50.6324 55.0457 52.5113Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9408 32.4117L32.9193 28.3903C32.3642 27.8351 31.4639 27.8351 30.9086 28.3903C30.3534 28.9456 30.3534 29.8458 30.9086 30.401L34.9301 34.4224C35.4853 34.9777 36.3857 34.9777 36.9408 34.4224C37.4961 33.8672 37.4961 32.967 36.9408 32.4117Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9381 44.0596H25.1562C24.371 44.0596 23.7344 44.6962 23.7344 45.4814C23.7344 46.2666 24.371 46.9032 25.1562 46.9032H30.9381C31.7233 46.9032 32.3599 46.2666 32.3599 45.4814C32.3599 44.6962 31.7233 44.0596 30.9381 44.0596Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8446 44.0598H65.0627C64.2775 44.0598 63.6409 44.6964 63.6409 45.4816C63.6409 46.2668 64.2775 46.9034 65.0627 46.9034H70.8446C71.6298 46.9034 72.2664 46.2668 72.2664 45.4816C72.2664 44.6964 71.6298 44.0598 70.8446 44.0598Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0922 28.3904C64.5371 27.8352 63.6369 27.8352 63.0815 28.3904L59.06 32.4118C58.5047 32.967 58.5047 33.8673 59.06 34.4226C59.6152 34.9778 60.5154 34.9778 61.0707 34.4226L65.0922 30.4011C65.6475 29.846 65.6475 28.9457 65.0922 28.3904Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9997 21.2161C47.2145 21.2161 46.5779 21.8527 46.5779 22.6379V28.4199C46.5779 29.2051 47.2145 29.8417 47.9997 29.8417C48.7849 29.8417 49.4215 29.2051 49.4215 28.4199V22.6379C49.4215 21.8527 48.7849 21.2161 47.9997 21.2161Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9987 38.3725C47.4143 38.3725 46.8189 38.4425 46.2302 38.5805C43.7785 39.1527 41.7261 41.1708 41.1232 43.6021C40.9342 44.3643 41.3987 45.1353 42.1608 45.3244C42.9231 45.5134 43.6941 45.0487 43.8831 44.2867C44.2301 42.8878 45.461 41.6801 46.8777 41.3494C47.2551 41.2609 47.6324 41.2161 47.9987 41.2161C48.7839 41.2161 49.4205 40.5795 49.4205 39.7943C49.4205 39.0091 48.7839 38.3725 47.9987 38.3725Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1767_5168",
    x: 0.49292,
    y: 0.896362,
    width: 95.0142,
    height: 102.689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1767_5168"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1767_5168"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1767_5168",
    result: "effect2_dropShadow_1767_5168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1767_5168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1767_5168",
    x1: 27.9184,
    y1: 18.5752,
    x2: 68.185,
    y2: 75.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C4D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBadgeIcon);
export default __webpack_public_path__ + "static/media/knowledge-badge-icon.b2d314dfa7bd5dbc5524ee030938a883.svg";
export { ForwardRef as ReactComponent };